export default "__VITE_ASSET__DW5MomrJ__"